import PropTypes from 'prop-types';

const TextField = ({ name, type = 'text', defaultValue, onChange }) => (
  <input
    type={type}
    className="critere-input"
    value={defaultValue.valeur || ''}
    title={defaultValue.valeur || ''}
    name={name}
    onChange={(event) => onChange({ valeur: event.target.value ?? '' })}
  />
);

TextField.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  defaultValue: PropTypes.shape({
    valeur: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
};

export default TextField;
